import {
  INPUT_NUMBER,
  GET_RATES,
  NEW_UUID_ORDER_ID,
  CONVERT_CURRENCY,
  SELECTOR_CHANGED,
  RUN_KYC,
  STORE_PARAMS,
  NEW_ERROR,
  RESET_ERROR,
  GET_IP,
  GET_URL,
  GET_MOONPAY_URL,
} from "../actions";

const initialState = {
  fiat_amount: "0.00",
  ltc_amount: "0",
  rates: {
    quote_id: "",
    base_amount: "",
    total_amount: "",
    valid_until: "",
    digital_amount: null,
  },
  order_id: "",
  selected_fiat: true,
  is_kyc_update_required: false,
  params: {
    address: "",
    currencyCode: "",
    appInstallDate: "",
    user_id: "",
    currencySymbol: "",
  },
  errors: {
    error: false,
    messages: [],
  },
  ip: "",
  moonpayURL: "",
  url: {
    currentReturnBaseURL: "",
    currentPostURL: "",
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case INPUT_NUMBER:
      return {
        ...state,
        fiat_amount: action.payload,
      };
    case GET_RATES:
      return {
        ...state,
        rates: action.payload,
      };
    case NEW_UUID_ORDER_ID:
      return {
        ...state,
        order_id: action.payload,
      };
    case CONVERT_CURRENCY:
      return {
        ...state,
        ltc_amount: action.payload,
      };
    case SELECTOR_CHANGED:
      return {
        ...state,
        selected_fiat: action.payload,
      };
    case RUN_KYC:
      return {
        ...state,
        is_kyc_update_required: action.payload,
      };
    case STORE_PARAMS:
      return {
        ...state,
        params: action.payload,
      };
    case NEW_ERROR:
      return {
        ...state,
        errors: action.payload,
      };
    case RESET_ERROR:
      return {
        ...state,
        errors: action.payload,
      };
    case GET_IP:
      return {
        ...state,
        ip: action.payload,
      };
    case GET_MOONPAY_URL:
      return {
        ...state,
        moonpayURL: action.payload,
      };
    case GET_URL:
      return {
        ...state,
        url: action.payload,
      };
    default:
      return state;
  }
}
